module.exports = __webpack_public_path__ + "static/media/3.6972a2ee.png";